import { entranceNotes } from '@/mocks/movies';

export default function Entrance() {
  return (
    <section id="entrance" className="w-full bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 text-primary-700 text-xs md:text-sm font-medium tracking-wide">
            <i className="ri-link-m" />
            网址入口
          </span>
          <h2 className="mt-3 font-heading font-bold text-2xl md:text-4xl text-foreground-950 text-balance">
            网页入口与网址的使用说明
          </h2>
          <p className="mt-4 text-foreground-700 text-sm md:text-base leading-relaxed">
            很多人搜索「九七电影院网址」时，最想知道的是怎么稳定地找到同一个页面。下面几点是关于网页入口的通用建议，
            能帮你在下次访问时少走一些弯路。
          </p>
        </div>

        <div className="mt-9 grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          {entranceNotes.map((n) => (
            <article
              key={n.title}
              className="flex gap-4 rounded-lg bg-background-100/70 border border-background-200/80 p-5 md:p-6"
            >
              <div className="w-11 h-11 md:w-12 md:h-12 shrink-0 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 text-xl">
                <i className={n.icon} />
              </div>
              <div>
                <h3 className="font-heading font-semibold text-base text-foreground-950">{n.title}</h3>
                <p className="mt-2 text-foreground-600 text-xs md:text-sm leading-relaxed">{n.desc}</p>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-6 rounded-lg overflow-hidden border border-background-200/80 bg-primary-50 p-6 md:p-8 flex flex-col md:flex-row md:items-center gap-6">
          <div className="flex-1">
            <h3 className="font-heading font-bold text-lg md:text-xl text-foreground-950">
              把本页收藏起来，下次直接打开
            </h3>
            <p className="mt-2.5 text-foreground-700 text-xs md:text-sm leading-relaxed">
              收藏后无需再次搜索，也不必担心记错网址。无论你在手机还是电脑上浏览，书签都能保持一致的使用习惯，
              让你把注意力放在内容本身，而不是反复寻找入口。
            </p>
          </div>
          <div className="flex flex-wrap gap-3 shrink-0">
            <a
              href="#top"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              <i className="ri-arrow-up-line" />
              回到页面顶部
            </a>
            <a
              href="#faq"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md border border-primary-300 bg-background-50 text-primary-800 text-sm font-medium hover:bg-primary-100 transition-colors whitespace-nowrap"
            >
              再看常见问题
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}